// extracted by mini-css-extract-plugin
module.exports = {"title":"AlertMessage_title__3i8_i","subtitle":"AlertMessage_subtitle__1VNH6","links":"AlertMessage_links__lP-vO","link":"AlertMessage_link__1CmrZ"};